import {
  HttpEvent,
  HttpEventType,
  HttpResponse,
  HttpUploadProgressEvent,
} from '@angular/common/http';
import { Observable, OperatorFunction, of } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

export const uploadProgress: {
  <T>(): OperatorFunction<HttpEvent<T>, HttpUploadProgressEvent | T>;
  <T, R>(
    restOperator: OperatorFunction<Exclude<HttpEvent<T>, HttpUploadProgressEvent>, R>,
  ): OperatorFunction<HttpEvent<T>, HttpUploadProgressEvent | R>;
} = <T>(
  operator?: OperatorFunction<Exclude<HttpEvent<T>, HttpUploadProgressEvent>, any>,
): OperatorFunction<HttpEvent<T>, HttpUploadProgressEvent | any> => {
  const restOperator =
    operator ??
    (obs =>
      obs.pipe(
        filter((ev): ev is HttpResponse<T> => ev.type === HttpEventType.Response),
        map(ev => ev.body),
      ));

  return (source: Observable<HttpEvent<T>>) =>
    source.pipe(
      switchMap(ev =>
        ev.type === HttpEventType.UploadProgress ? of(ev) : of(ev).pipe(restOperator),
      ),
    );
};
